import React from "react";
import "./style.m.less";

const HorizontalMenu = props => {
  const { selectedKeys, setCurrentKey, menus } = props;
  
  const onClick = (item) => {
    setCurrentKey?.(item?.key);
    item?.operation?.();
  };

  return (
    <ul className="mene_ul">
      {menus?.map(item => {
        const isCurrent = selectedKeys === item?.key; // 当前项
        return (
          <li className={`mene_li ${isCurrent ? "mene_li_active" : ""}`} onClick={() => onClick?.(item)} key={item?.key}>
            <span>{item?.label}</span>
          </li>
        );
      })}
    </ul>
  )
};

export default HorizontalMenu;